import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import ShareExperienceModal from './ShareExperienceModal';

const BlogShareExperienceCTA = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="blog-share-experience-cta">
      <div className="blog-share-experience-cta__pattern" />
      <div className="container blog-share-experience-cta__content">
        <h3 className="blog-share-experience-cta__title">
          Got a Story to Share?
        </h3>
        <p className="blog-share-experience-cta__subtitle">
          Inspire our community with your boating tips, unforgettable moments, and lessons learned.
        </p>
        <button 
          className="blog-share-experience-cta__button" 
          onClick={() => setShowModal(true)}
        >
          <FontAwesomeIcon icon={faShare} />
          Share Your Experience
        </button>
      </div>
      {showModal && <ShareExperienceModal onClose={() => setShowModal(false)} />}
    </section>
  );
};

export default BlogShareExperienceCTA;


